import './App.scss';
import Home from './pages/Home';
import {Routes, Route} from 'react-router-dom';
import About from './pages/About';
import Services from './pages/Services';
import BlogsPage from './pages/BlogsPage';
import SingleBlog from './pages/SingleBlog/SingleBlog';
import Contactus from './pages/Contact/Contactus';
import { BookingProvider } from './components/BookingModal/BookingModal';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import AdminLogin from './pages/Admin/AdminLogin';
import AdminLayout from './pages/Admin/AdminLayout';
import Dashboard from './pages/Admin/Dashboard';
import SlotsManager from './pages/Admin/SlotsManager';
import AppointmentsManager from './pages/Admin/AppointmentsManager';
import ScheduleView from './pages/Admin/ScheduleView';

function App() {
  return (
    <AuthProvider>
      <BookingProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/singleservice" element={<Services />} />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/blog/:url" element={<SingleBlog />} />
          <Route path="/contact" element={<Contactus />} />
          {/* Admin routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="slots" element={<SlotsManager />} />
            <Route path="appointments" element={<AppointmentsManager />} />
            <Route path="schedule" element={<ScheduleView />} />
          </Route>
        </Routes>
      </BookingProvider>
    </AuthProvider>
  );
}

export default App;
